<template>
    <QueueDisplay :total="count">
        <template v-slot:icon>
            <WarehouseIcon />
        </template>
    </QueueDisplay>
</template>

<script>
import {ref,onMounted,onUnmounted,watch} from 'vue'
import api from "@/api"
import WarehouseIcon from "../customIcons/WarehouseIcon.vue"
import QueueDisplay from "@/components/ui/QueueDisplay.vue"

export default {
    components:{QueueDisplay,WarehouseIcon},
    emits:['count'],
    setup (props, { emit }) {
        const count = ref(0)

    // Watchers
        watch(count, (value) => emit('count', Number(value) || 0), { immediate: true })

        onMounted (()=>{
            getInitialCount()
            joinRoom()
            window.addEventListener('socket_connected', handleReconnect);
            window.addEventListener("warehouse_queue", handleWebSocketData);
        })

        onUnmounted (()=>{
            window.removeEventListener("socket_connected", handleReconnect);
            window.removeEventListener("warehouse_queue",handleWebSocketData)
        })

        const handleWebSocketData = (e)=>{
            const data = Number(e.detail?.data)
            if (isNaN(data)) {
                count.value = 0;
            } else {
                count.value = data
            }
        }

        const joinRoom = ()=>{
            let eventJoin = new CustomEvent("requestRoom", {detail: { route: "warehouse", room: "warehouse_queue" }});
            dispatchEvent(eventJoin);
        }

        const handleReconnect = ()=>{
            joinRoom()
        }

        const getInitialCount = async ()=>{
            await api
            .get("logistics/warehouseQueueCount")
            .then((res)=>{
                const n = res.data?.data != null ? Number(res.data.data) : NaN
                count.value = Number.isFinite(n) ? n : 0
            })
            .catch((err)=>{
                console.error(err.response?.data?.error || err.message)
            })
        }

        return {count}
    }

}
</script>

<style>

</style>